function DealLocation({ deal }) {
  // Some deals don't have a geocoded propertyLocation (agent didn't pick
  // from Google autocomplete, or the deal pre-dates the geocoding).
  // Fall back to text-only address rather than crashing.
  const hasCoords =
    deal?.propertyLocation &&
    typeof deal.propertyLocation === "object" &&
    deal.propertyLocation.lat != null &&
    deal.propertyLocation.lng != null;

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <div className="border-b border-black/10 pb-2">
        <h3 className="text-lg font-semibold">Property Location</h3>
        <p className="text-gray-700">{deal?.propertyaddress || "—"}</p>
      </div>
      {hasCoords ? (
        <div className="w-full h-64 rounded-lg overflow-hidden mt-4">
          <iframe
            title="Google Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            src={`https://www.google.com/maps?q=${deal.propertyLocation.lat},${deal.propertyLocation.lng}&hl=es;z=14&output=embed`}
          ></iframe>
        </div>
      ) : (
        <div className="w-full mt-4 text-sm text-gray-500 italic">
          Map unavailable — no geocoded coordinates on this deal.
        </div>
      )}
    </div>
  );
}

export default DealLocation;
